import styled from 'styled-components'

export const LinksWrapper = styled.div`
  justify-content: center;

  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
`
